export function urlCleaner(str) {
    return str.replace('/en', '').replace('/uz', '')
}